module.exports = __webpack_public_path__ + "res/left_arrow_icon.png";